import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import "./Logoutmodal.css";
const Logoutmodal = (props) => {
  return (
    <>
      <Modal
        {...props}
        size="md"
        centered
        aria-labelledby="contained-modal-title-vcenter"
        className="logoutmodal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Confirm Log Out
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="logout-icon">
            <FontAwesomeIcon icon={faRightFromBracket} />
          </div>
          <p className="logout-text">Are you sure you want to log out?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide} className="nobtn">
            No
          </Button>
          <Button onClick={props.LogOut} className="yesbtn">
            Yes, Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Logoutmodal;
